import React from 'react';
import EditMaterial from '../materials/EditMaterial';
import EditModelpack from '../modelpacks/EditModelpack';
import EditModel from '../models/EditModel';
import EditModifier from '../modifiers/EditModifier';
import { useMaterialServiceGetBackendv2Material1, useModelpackServiceGetBackendv2Modelpack1, useModelServiceGetBackendv2Model1, useModifierServiceGetBackendv2Modifier1 } from '../../backendapi/queries';
import { AssetProjectAsset } from '../../backendapi/requests';

const EditAssetProjectItem: React.FC<{ asset?: AssetProjectAsset, isOpen: boolean, onClose: () => void }> = ({ asset, isOpen, onClose }) => {

    console.log(asset);

    const material = useMaterialServiceGetBackendv2Material1({key: asset?.itemId ?? 0}, undefined, {enabled: (asset !== undefined && asset.assetType === "Material")});
    const model = useModelServiceGetBackendv2Model1({key: asset?.itemId ?? 0}, undefined, {enabled: asset !== undefined && asset.assetType === "Model"});
    const modifier = useModifierServiceGetBackendv2Modifier1({key: asset?.itemId ?? 0}, undefined, {enabled: asset !== undefined && asset.assetType === "Modifier"});
    const modelPack = useModelpackServiceGetBackendv2Modelpack1({key: asset?.itemId ?? 0}, undefined, {enabled: asset !== undefined && asset.assetType === "Modelpack"});

    return (
        <>
            {(asset && asset.assetType === "Material") && <EditMaterial materialId={material?.data?.id} isOpen={isOpen} onClose={onClose} />}
            {(asset && asset.assetType === "Model") && <EditModel modelId={model?.data?.id} isOpen={isOpen} onClose={onClose} />}
            {(asset && asset.assetType === "Modelpack") && <EditModelpack modelpackId={modelPack?.data?.id} isOpen={isOpen} onClose={onClose} />}
            {(asset && asset.assetType === "Modifier") && <EditModifier modifierId={modifier?.data?.id} isOpen={isOpen} onClose={onClose} />}
        </>
    );
};

export default EditAssetProjectItem;